import api from "!../node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../node_modules/css-modules-typescript-loader/index.js!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[2]!./AppToast.module.css";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};